import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { changePassword } from '../api/client';
import toast from 'react-hot-toast';
import { Eye, EyeOff, ShieldAlert } from 'lucide-react';

const LABELS = {
  de: { title:'Passwort ändern', sub:'Aus Sicherheitsgründen müssen Sie Ihr Passwort ändern, bevor Sie fortfahren.',
        npw:'Neues Passwort', conf:'Passwort bestätigen', btn:'Passwort speichern', logout:'Abmelden',
        min:'Mindestens 8 Zeichen erforderlich', nomatch:'Passwörter stimmen nicht überein',
        ok:'Passwort aktualisiert', err:'Fehler beim Speichern' },
  tr: { title:'Şifre Değiştir', sub:'Güvenlik nedeniyle devam etmeden önce şifrenizi değiştirmelisiniz.',
        npw:'Yeni şifre', conf:'Şifreyi onayla', btn:'Şifreyi kaydet', logout:'Çıkış yap',
        min:'En az 8 karakter gerekli', nomatch:'Şifreler eşleşmiyor',
        ok:'Şifre güncellendi', err:'Kaydetme hatası' },
  en: { title:'Change Password', sub:'For security you must change your password before continuing.',
        npw:'New password', conf:'Confirm password', btn:'Save password', logout:'Log out',
        min:'At least 8 characters required', nomatch:'Passwords do not match',
        ok:'Password updated', err:'Save failed' },
};

export default function ForcePasswordChange() {
  const { user, logout, clearMustChange } = useAuth();
  const L = LABELS[user?.lang && LABELS[user.lang] ? user.lang : 'de'];
  const [pw, setPw]   = useState('');
  const [pw2, setPw2] = useState('');
  const [show, setShow]       = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    if (pw.length < 8) { toast.error(L.min); return; }
    if (pw !== pw2)    { toast.error(L.nomatch); return; }
    setLoading(true);
    try {
      await changePassword(user.id, pw);
      toast.success(L.ok);
      clearMustChange();               // unblocks the app
    } catch {
      toast.error(L.err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <h1 style={{display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
            <ShieldAlert size={22}/> {L.title}
          </h1>
          <p>{L.sub}</p>
        </div>
        <form onSubmit={submit} style={{display:'flex',flexDirection:'column',gap:14}}>
          <div className="fg">
            <label>{L.npw}</label>
            <div style={{position:'relative'}}>
              <input
                type={show?'text':'password'} autoComplete="new-password" autoFocus
                value={pw} onChange={e=>setPw(e.target.value)} placeholder="••••••••"
                style={{width:'100%',paddingRight:40}}
              />
              <button
                type="button" onClick={()=>setShow(v=>!v)}
                style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',
                  background:'none',border:'none',cursor:'pointer',color:'var(--muted)',padding:0,display:'flex',alignItems:'center'}}
              >
                {show ? <EyeOff size={16}/> : <Eye size={16}/>}
              </button>
            </div>
          </div>
          <div className="fg">
            <label>{L.conf}</label>
            <input
              type={show?'text':'password'} autoComplete="new-password"
              value={pw2} onChange={e=>setPw2(e.target.value)} placeholder="••••••••"
            />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{width:'100%',justifyContent:'center',padding:'10px',marginTop:4}}>
            {loading ? <span className="spinner"/> : L.btn}
          </button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={logout}
            style={{justifyContent:'center'}}>
            {L.logout}
          </button>
        </form>
      </div>
    </div>
  );
}
